var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Facebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.1,1.35H40.3C18.3,1.35.4,19.15.4,41.25v358.8c0,22,17.8,39.9,39.9,39.9h199.3v-179.4h-59.8v-59.8h59.8v-32.1c0-60.8,29.6-87.5,80.2-87.5,24.2,0,37,1.8,43.1,2.6v57.2h-34.5c-21.4,0-28.9,11.3-28.9,34.2v25.6h62.9l-8.5,59.8h-54.5v179.4h99.7c22,0,39.9-17.8,39.9-39.9V41.25c-.1-22.1-17.9-39.9-39.9-39.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Facebook);
export default __webpack_public_path__ + "static/media/icons8-facebook.685cd233ba212cca234ed35f350507eb.svg";
export { ForwardRef as ReactComponent };